// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"22":"b223bfc6","143":"1252299b","220":"efb36f54","362":"dacfdb67","513":"a36d2d9d","937":"044832ae","951":"3fd08749"}[chunkId] + ".js";
};